import React from 'react';
import GlobalStyle from '../../src/styles/globalStylesV2';
import NewFooter from '../../src/components/HomePage/NewFooter';
import NewHeader from '../../src/components/HomePage/NewHeader';
import { categoryNavBarDataFetcher } from '../../src/datafetchers/CategoryPage';
import SitemapComponent from '../../src/components/SitemapComponent';
// import {
//     getArticleUrl,
//     getPostUrl,
//     getTopicUrl,
// } from "../../src/datafetchers/CommunitySitemap";
import { getStaticPagesData } from '../../src/Constants/StaticPages';
import { getFilteredCategoryContent } from '../../src/Utils/helper';
import { MainContainer } from '../../src/components/Product/PdpHeader/styled';

export async function getStaticProps(context) {
  let categoryNavBarApiData = {};
  let product_urls = {};
  let article_urls = {};
  let topic_urls = {};
  let question_urls = {};
  //   let clinic_urls = {};
  try {
    categoryNavBarApiData = await categoryNavBarDataFetcher();
    // product_urls = await getAllProductIDs();
    // article_urls = await getArticleUrl();
    // topic_urls = await getTopicUrl();
    // question_urls = await getPostUrl();
    //   clinic_urls = await getAllProductIDs("clinic");
  } catch (error) {
    if (error.response.status == '400' || error.response.status == '404') {
      return {
        notFound: true,
        revalidate: 60,
      };
    } else throw error;
  }
  return {
    props: {
      categoryNavBarData: getFilteredCategoryContent(
        categoryNavBarApiData?.data,
      ),
      // product_urls: product_urls?.data,
      // article_urls: article_urls?.data,
      // topic_urls: topic_urls?.data,
      // question_urls: question_urls?.data,
      static_pages: getStaticPagesData('Static'),
      // clinic_urls: clinic_urls?.data,
      //health_urls: getStaticPagesData("Health"),
      product_category: getStaticPagesData('productCategory'),
    },
    revalidate: 60,
  };
}

function index(props) {
  const {
    categoryNavBarData,
    product_urls,
    article_urls,
    question_urls,
    topic_urls,
    static_pages,
    // clinic_urls,
    // health_urls,
    product_category,
  } = props;
  const siteMapUrls = {
    product_urls,
    article_urls,
    question_urls,
    topic_urls,
    categoryNavBarData,
    static_pages,
    // clinic_urls,
    //  health_urls,
    product_category,
  };
  return (
    <>
      <GlobalStyle />
      <NewHeader
        showOldSubHeader={true}
        categoryData={categoryNavBarData}
        showCart={true}
        showTrackOrder={true}
        nostrip={true}
      />
      <MainContainer paddingTop="180px" categ subCategory fullWidth>
        <SitemapComponent siteMapUrls={siteMapUrls} />
      </MainContainer>
      <NewFooter />
    </>
  );
}

export default index;
